import { render } from "./PbxDashboard.vue?vue&type=template&id=4dc4446a"
import script from "./PbxDashboard.vue?vue&type=script&lang=js"
export * from "./PbxDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script